<template>
  <div>
    <div class="container py-3">
      <div class="p-3 bg-white rounded shadow mb-5">

        <div class="row">
          <div class="col-12">

            <div class="d-flex mb-2">
              <h3 class="mr-auto"><span class="badge badge-pill badge-primary mb-1">Activities</span></h3>

              <div>
                <button class="btn btn-secondary mb-0" @click="goBack">
                  <font-awesome-icon icon="chevron-left" />
                  Back
                </button>
              </div>
            </div>

            <table class="table table-hover">
              <thead class="thead-light">
              <tr>
                <th scope="col" style="width: 2vw;">#</th>
                <th scope="col">Subject</th>
                <th scope="col" style="width: 9vw;">Log Date</th>
              </tr>
              </thead>

              <tbody v-if="isLoading">
              <tr>
                <td colspan="100%">
                  <base-loader></base-loader>
                </td>
              </tr>
              </tbody>

              <tbody v-else>
              <tr v-for="(crew_activity,index) in crewActivity" :key="crew_activity.id">
                <th scope="row">{{ index + 1 }}</th>
                <td class="text-left">
                  <a class="text-dark" role="button" @click="viewCircularFile(crew_activity.circularId)">
                    {{ crew_activity.circular }}
                  </a>
                </td>
                <td>{{ eliteDateFormat(crew_activity.log_date) }}</td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '@/mixins/app.mixins';
import {AppService} from '@/service/app.service';
import {FileService} from '@/service/file.service';

export default {
  name: 'CrewActivity',

  /**mixins**/
  mixins: [AppMixins],

  /**data**/
  data() {
    return {
      crewLogId: this.$route.params.crewLogId,
    };
  },

  methods: {
    ...mapActions([
      'viewCrewLogActivity',
      'getCircularFile',
    ]),

    eliteDateFormat(date) {
      return AppService.dateEliteFormat(date);
    },

    async viewCircularFile(circular) {
      let response = await this.getCircularFile(circular);
      if (!response.errors) {
        FileService.viewDocument(response.file, response.file_name);
      }
    },

  },

  /**  computed  **/
  computed: {
    ...mapGetters([
      'crewActivity',
      'crewLogs',
      'isLoading',
    ]),

  },

  /** created **/
  created() {
    this.viewCrewLogActivity(this.crewLogId);
  },

};
</script>

<style scoped>

</style>
